import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'

const Icon = () => {
  return (
    <ArrowDownwardIcon
      htmlColor='rgba(0, 0, 0, 0.54)'
      fontSize='medium'
    />
  )
}

export default Icon
